import React from "react";
import { Drawer, DrawerProps } from "@mui/material";
import { IoMdClose } from "react-icons/io";

/* eslint @typescript-eslint/no-explicit-any: ["off"] */
export interface DrawerCommonProps {
    title: string;
    show: boolean;
    handleClose: any;
    children?: any;
    additionalProps?: Partial<DrawerProps>;
}

const DrawerCommon: React.FC<DrawerCommonProps> = ({ title, show, handleClose, children, additionalProps }) => {
    return (
        <Drawer anchor="right" open={show} onClose={handleClose} {...additionalProps}>
            <div className="common-drawer">
                <h5 className="header-title">{title}</h5>
                <IoMdClose className="btn-close" onClick={handleClose} />
                <div>{children}</div>
            </div>
        </Drawer>
    );
};

export default DrawerCommon;
